import type { Dayjs } from "dayjs";

// Timestamps are edited as a separate date and time control, so the two halves have to
// be recombined before submission. Seconds and milliseconds are dropped because neither
// picker exposes them and carrying the original's would make an unedited field look
// changed to the diff on the server.
export const combineDateAndTime = (
  date: Dayjs | null,
  time: Dayjs | null
): Dayjs | null =>
  date && time
    ? date.hour(time.hour()).minute(time.minute()).second(0).millisecond(0)
    : null;
